import VueRouter from "vue-router";
import routes from "./routes";

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkExactActiveClass: "active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) =>{
  const publicPages = ['/login', '/register', '/email-confirmation'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user')
  if(authRequired && !loggedIn){
    next('/login');
  }else
    next();
});

export default router;
